import * as React from 'react';
import { __ } from 'react-i18n';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenterVertical } from '../../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../../Defaults/Text';

interface Props {
  title: string;
  value: string;
  borderBottom?: boolean;
}

function ModalMobileValue({ title, value }: Props) {
  return (
    <ValueRow>
      <TypeOfValue>{title}</TypeOfValue>
      <Value>{value}</Value>
    </ValueRow>
  );
}

const ValueRow = styled(FlexRowCenterVertical)`
  justify-content: space-between;
  width: 100%;
  margin-bottom: ${rem(16)};
`;

const TypeOfValue = styled(TextP)`
  font-family: ${({ theme }) => theme.font.secondary};
  font-weight: 400;
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  margin-right: ${rem(32)};
`;

const Value = styled(TextP)`
  font-size: ${rem(14)};
  font-family: ${({ theme }) => theme.font.secondaryLight};
  font-weight: 400;
  line-height: ${rem(22)};
  white-space: nowrap;
`;

export { ModalMobileValue };
